import React, { useEffect, useState } from 'react'
import { Moment } from 'moment'
import moment from 'moment-timezone'
import { ActivityModule, ActivityType, ProjectStatus, ProjectPriority } from '../models/activities'
import { SmartlyActionItems } from '@Techedge/digitalportal-shared'

export const sortArray = (array) => {
    return array.sort((a, b) => {
        return a.id - b.id
    })
}

export const formatDate = (date: string, format?: string) => {
    const newDate = new Date(date)
    return moment(moment.utc(newDate).format()).format(format ? format : 'DD/MM/YYYY HH:mm')
}

export const formatDateRequest = (date: string) => {
    const newDate = new Date(date)
    const formatDate = moment(moment.utc(newDate).format()).format('YYYY-MM-DD')
    return formatDate + 'T00:00:00.000Z'
}

export const formatDateLocale = (date: string) => {
    const locale = window?.navigator?.language
    // moment.locale(locale)
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('L')
    const dateMomentObj = moment(date, 'DD/MM/YYYY')
    const dateObj = dateMomentObj.toDate()
    const dateObjToStr = dateObj.toString()
    return moment(dateObjToStr).format(format)
}

export const formatDateLocaleCalendar = (date: string) => {
    // const locale = window?.navigator?.language
    // moment.locale(locale)
    // const localeData = moment.localeData()
    // const format = localeData.longDateFormat('L')
    const dateMomentObj = moment(date, 'DD/MM/YYYY')
    const dateObj = dateMomentObj.toDate()
    const dateObjToStr = dateObj.toString()
    return `${moment(dateObjToStr).format('dddd').substring(0, 3).charAt(0).toUpperCase()}${moment(
        dateObjToStr
    )
        .format('dddd')
        .substring(0, 3)
        .slice(1)}, ${moment(dateObjToStr).format('DD')} ${moment(dateObjToStr)
        .format('MMMM')
        .substring(0, 3)
        .charAt(0)
        .toUpperCase()}${moment(dateObjToStr).format('MMMM').substring(1, 3)}`
}

export const findGetParameter = (parameterName) => {
    var result = null,
        tmp = []
    var items = location.search.substr(1).split('&')
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
    }
    return result
}

export const changeBreadcrumbs = (title?: string) => {
    let breadcrumbs = document.getElementsByClassName('wardrobe-breadcrumb')[0]
        .firstChild as HTMLElement
    let breadcrumbsLast = breadcrumbs.lastChild.firstChild.firstChild as HTMLElement
    breadcrumbsLast.innerText = title ? title : '-'
}

export const getQuery = (obj: any): string => {
    let haveAlreadyParams: boolean = false
    let query: string = ''
    if (obj) {
        query += '?'
        Object.keys(obj).map((key) => {
            const value: any = obj[key]
            if (value !== null && value !== undefined && value.toString().length > 0) {
                if (haveAlreadyParams) {
                    query += '&'
                }
                query += key + '=' + JSON.stringify(value)
                haveAlreadyParams = true
            }
        })
        if (!haveAlreadyParams) {
            return ''
        }
    }
    return query
}

export const s2ab = (s: any) => {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
}

export const getDifferences = (array1: any[], array2: any[], field: string) => {
    return array1.filter((object1) => {
        return !array2.some((object2) => {
            return object1[field] === object2[field]
        })
    })
}

export const isMobileChecker = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return isMobile
}

export const getRemainingDays = (startDate: Moment, endDate: Moment): number => {
    return endDate.diff(startDate, 'days')
}

export const formatActivityType = (activityType: string) => {
    switch (activityType) {
        case 'reminder':
            return ActivityType.REMINDER
        case 'reaction':
            return ActivityType.REACTION
        case 'task':
            return ActivityType.EVENT_WITH_TASK
        case 'visit':
            return SmartlyActionItems.VISIT
        default:
            return ActivityType.EVENT_GENERIC
    }
}

export const formatProjectPriority = (projectPriority: string) => {
    switch (projectPriority) {
        case 'standard':
            return ProjectPriority.NORMAL
        case 'high':
            return ProjectPriority.HIGH
        case 'urgent':
            return ProjectPriority.URGENT
        default:
            return ProjectPriority.NORMAL
    }
}

export const formatProjectStatus = (projectStatus: string) => {
    switch (projectStatus) {
        case 'draft':
            return ProjectStatus.DRAFT
        case 'released':
            return ProjectStatus.RELEASED
        case 'rejected':
            return ProjectStatus.REJECTED
        case 'new':
            return ProjectStatus.NEW
        case 'read':
            return ProjectStatus.READ
        case 'in-progress':
            return ProjectStatus.IN_PROGRESS
        case 'pre-closed':
            return ProjectStatus.PRE_CLOSED
        case 'in-approval':
            return ProjectStatus.IN_APPROVAL
        case 'redo':
            return ProjectStatus.REDO
        case 'closed':
            return ProjectStatus.CLOSED
        case 'overdue':
            return ProjectStatus.OVERDUE
        case 'cancelled':
            return ProjectStatus.CANCELLED
        case 'toBeReleased':
            return ProjectStatus.TO_BE_RELEASED
        default:
            return projectStatus
    }
}

export const formatSourceModule = (sourceModule: string) => {
    switch (sourceModule) {
        case 'news':
            return ActivityModule.NEWS
        case 'visit':
            return ActivityModule.VISIT
        case 'communication':
            return ActivityModule.COMMUNICATION
        default:
            return sourceModule
    }
}

export const formatDateTZ = (date: string, timeZone: string) => {
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('L')
    return moment.tz(new Date(date), timeZone).format(format)
}
